import React, { Component } from "react";

// CSS
import "../../styles/newDesign.scss";
import "./Courses.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { resolveTenant, listCourseCatalog, requestSubscription, isLoggedIn } from "../../Helper/Api";

const properties = require("../../properties.json");

class Courses extends Component {
  state = {
    tenant: null,
    notFound: false,
    courses: [],
    subscribing: null, // course id currently being requested
    msg: null,
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        document.title = properties.site_name + " - Courses";
        this.setState({ tenant });
        return listCourseCatalog(tenant.teacherUserId);
      })
      .then((courses) => this.setState({ courses: courses || [] }))
      .catch(() => this.setState({ notFound: true }));
  }

  subscribe = (course) => {
    if (!isLoggedIn()) {
      window.location.href = "/sign-in";
      return;
    }
    this.setState({ subscribing: course.id, msg: null });
    requestSubscription({ periodId: course.periodId, branchId: this.state.tenant.branchId })
      .then(() => {
        this.setState({ subscribing: null, msg: { text: "Your subscription request has been sent and will be reviewed by the teacher soon", type: "success" } });
      })
      .catch((error) => {
        this.setState({ subscribing: null, msg: { text: error.message || "Could not send the request", type: "warning" } });
      });
  };

  render() {
    const { tenant, notFound, courses, subscribing, msg } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="nd-hero">
            <div className="nd-wrap">
              <div className="nd-eyebrow">Our Courses</div>
              <h1>Courses</h1>
              <p>Focused courses covering the full workflow — from concept to final render.</p>
            </div>
          </div>

          <div className="nd-section nd-wrap">
            {msg && <div className={`crs-msg ${msg.type}`}>{msg.text}</div>}

            {courses.length === 0 ? (
              <p style={{ color: "var(--nd-muted)" }}>No courses available right now.</p>
            ) : (
              <div className="crs-grid">
                {courses.map((course) => (
                  <div className="crs-card" key={course.id}>
                    {(() => {
                      const cardImage = course.listImage || course.image;
                      return (
                        <a href={`/courses/${course.id}`} className="crs-thumb" style={cardImage ? { backgroundImage: `url(${cardImage})`, backgroundSize: "cover", backgroundPosition: "center" } : undefined}></a>
                      );
                    })()}
                    <div className="crs-body">
                      <a href={`/courses/${course.id}`}><h3>{course.title}</h3></a>
                      {course.description && <p>{course.description}</p>}
                      <button
                        type="button"
                        className={`crs-enroll ${subscribing === course.id ? "loading" : ""}`}
                        disabled={subscribing === course.id}
                        onClick={() => this.subscribe(course)}
                      >
                        {subscribing === course.id ? "Sending ..." : "Request Subscription"}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="crs-journey">
              <div className="nd-eyebrow">The Full Journey</div>
              <h2>One Workflow, Start to Finish</h2>
              <div className="crs-journey-row">
                <div className="crs-journey-step">
                  <div className="crs-dot">01</div>
                  <div className="crs-label">Sketch</div>
                  <p>Capture ideas on paper or digitally.</p>
                </div>
                <div className="crs-journey-arrow">→</div>
                <div className="crs-journey-step">
                  <div className="crs-dot">02</div>
                  <div className="crs-label">Model</div>
                  <p>Bring your sketches to life in Rhino.</p>
                </div>
                <div className="crs-journey-arrow">→</div>
                <div className="crs-journey-step">
                  <div className="crs-dot">03</div>
                  <div className="crs-label">Render</div>
                  <p>Create stunning visuals and present.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default Courses;
